import moment from "moment";
import config from "../common/config";
import store from "../store";
import api from "../api";
import wx from "weixin-jsapi";
import { Toast } from "vant";

// 全局日志面板实例，用于在 H5 页面中展示调试信息
let logPanel = null;

/**
 * 一个DUBUG类，在开启debug时会在控制台输出相关信息，并在页面上展示调试面板
 */
class DEBUG {
    constructor(name) {
        this.flag = config.debug;
        this.mark = randomString(4);
        this.start_time = moment();
        this.name = name.toLocaleUpperCase();
        this.left_length = parseInt((50 - name.length) / 2);
        this.right_length = this.left_length + (name.length % 2);
        let timestamp = (moment().diff(config.start_time) / 1000)
            .toFixed(3)
            .toString()
            .replace(".", ":");

        const logStr = `[${this.mark} - 0ms - ${timestamp}] ${"-".repeat(this.left_length)} ${this.name} DEBUG START ${"-".repeat(this.right_length)}`;
        if (this.flag) {
            console.log(logStr);
            this.showInPanel(logStr);
        }
    }

    log(state, data) {
        for (let key in data) {
            let timestamp = (moment().diff(config.start_time) / 1000)
                .toFixed(3)
                .toString()
                .replace(".", ":");
            const logStr = `[${this.mark} - ${moment().diff(this.start_time)}ms - ${timestamp} - ${state}] ${key}: ${JSON.stringify(data[key])}`;
            if (this.flag) {
                console.log(logStr);
                this.showInPanel(logStr);
            }
        }
    }

    finish() {
        let timestamp = (moment().diff(config.start_time) / 1000)
            .toFixed(3)
            .toString()
            .replace(".", ":");
        const logStr = `[${this.mark} - ${moment().diff(this.start_time)}ms - ${timestamp}] ${"-".repeat(this.left_length + 1)} ${this.name} DEBUG END ${"-".repeat(this.right_length + 1)}`;
        if (this.flag) {
            console.log(logStr);
            this.showInPanel(logStr);
        }
    }

    /**
     * 在页面浮窗展示日志，适配小程序 web-view 调试
     */
    showInPanel(msg) {
        if (!config.debug) return;

        if (!logPanel) {
            logPanel = document.createElement("div");
            logPanel.id = "debug-log-panel";
            logPanel.style.cssText = `
                position: fixed;
                bottom: 10px;
                right: 10px;
                width: 250px;
                max-height: 200px;
                background: rgba(0, 0, 0, 0.7);
                color: #fff;
                font-size: 10px;
                padding: 8px;
                border-radius: 8px;
                overflow-y: auto;
                z-index: 9999;
                pointer-events: auto;
                word-break: break-all;
                border: 1px solid #444;
            `;

            // 添加标题和关闭按钮
            const title = document.createElement("div");
            title.innerHTML = 'DEBUG LOGS <span style="float:right; cursor:pointer;" onclick="this.parentElement.parentElement.style.display=\'none\'">X</span>';
            title.style.cssText = "border-bottom: 1px solid #666; padding-bottom: 4px; margin-bottom: 4px; font-weight: bold;";
            logPanel.appendChild(title);

            document.body.appendChild(logPanel);
        }

        const logItem = document.createElement("div");
        logItem.style.marginBottom = "2px";
        logItem.innerText = msg;
        logPanel.appendChild(logItem);
        logPanel.scrollTop = logPanel.scrollHeight;
    }
}
/**
 * 微信JS-SDK类，实例化后再调用相关方法
 */
class WX {
    constructor() {
        this.init();
    }
    async init() {
        if (config.is_dev) {
            console.log("Local development mode: skipping WX JSSDK initialization");
            return;
        }
        let debug = new DEBUG("WX JSSDK INIT");
        let app_id = store.state.wx_config.app_id;
        while (app_id === undefined) {
            await sleep(20);
        }
        debug.log("reday", { app_id });
        let url = location.href.split("#")[0];
        let nonce_str = randomString(32);
        let timestamp = parseInt(new Date().getTime() / 1000);
        let res = await api("getJsapiSignature", { url, nonce_str, timestamp });
        wx.config({
            // debug: config.debug,
            appId: app_id,
            timestamp,
            nonceStr: nonce_str,
            signature: res.signature,
            jsApiList: ["chooseImage", "uploadImage", "downloadImage", "startRecord", "stopRecord", "uploadVoice", "downloadVoice", "scanQRCode"],
        });
        wx.ready(() => {
            debug.log("finish", { status: "JSSDK Ready" });
            if (config.debug) Toast.success("微信JSSDK初始化成功");
            debug.finish();
        });
        wx.error((e) => {
            console.error(e);
            debug.log("failed", { error: e.message });
            if (config.debug) Toast.fail("微信JSSDK初始化失败");
            debug.finish();
        });
    }

    async scan() {
        let debug = new DEBUG("WX SCAN QRCODE");
        if (config.is_dev) {
            return config.wzy_url;
        }
        return new Promise((resolve, reject) => {
            if (config.debug) Toast.loading({ message: "正在启动扫码...", duration: 0 });
            wx.scanQRCode({
                needResult: 1, // 默认为0，扫描结果由微信处理，1则直接返回扫描结果，
                scanType: ["qrCode"], // 可以指定扫二维码还是一维码，默认二者都有
                success: (res) => {
                    debug.log("success", { result: res.resultStr });
                    if (config.debug) Toast.clear();
                    resolve(res.resultStr);
                },
                fail: (err) => {
                    debug.log("failed", { error: err.errMsg });
                    if (config.debug) Toast.fail("扫码失败: " + err.errMsg);
                    reject(err);
                },
                complete: () => {
                    debug.finish();
                },
            });
        });
    }

    async selectImage(count) {
        if (config.is_dev) {
            console.log("Local development mode: mocking selectImage");
            return "https://via.placeholder.com/300x400?text=Mock+Image";
        }
        let debug = new DEBUG("WX SELECT IMAGE");
        while (this.init === false) {
            await sleep(20);
        }
        return new Promise((resolve, reject) => {
            if (config.debug) Toast.loading({ message: "正在打开相册...", duration: 0 });
            wx.chooseImage({
                count,
                sizeType: ["original"],
                sourceType: ["album"],
                success: (res) => {
                    debug.log("success", { count: res.localIds.length });
                    if (config.debug) Toast.clear();
                    resolve(res.localIds[0]);
                },
                fail: (err) => {
                    debug.log("failed", { error: err.errMsg });
                    if (config.debug) Toast.fail("选择图片失败");
                    reject(err);
                },
                cancel: () => {
                    debug.log("cancel", { message: "User cancelled" });
                    if (config.debug) Toast.clear();
                    reject("cancel");
                },
                complete: () => {
                    debug.finish();
                },
            });
        });
    }
    async shootImage() {
        if (config.is_dev) {
            console.log("Local development mode: mocking shootImage");
            return "https://via.placeholder.com/300x400?text=Mock+Image";
        }
        let debug = new DEBUG("WX SHOOT IMAGE");
        while (this.init === false) {
            await sleep(20);
        }
        return new Promise((resolve, reject) => {
            if (config.debug) Toast.loading({ message: "正在打开相机...", duration: 0 });
            wx.chooseImage({
                count: 1,
                sizeType: ["original"],
                sourceType: ["camera"],
                success: (res) => {
                    debug.log("success", { localId: res.localIds[0] });
                    if (config.debug) Toast.clear();
                    resolve(res.localIds[0]);
                },
                fail: (err) => {
                    debug.log("failed", { error: err.errMsg });
                    if (config.debug) Toast.fail("拍照失败");
                    reject(err);
                },
                cancel: () => {
                    debug.log("cancel", { message: "User cancelled" });
                    if (config.debug) Toast.clear();
                    reject("cancel");
                },
                complete: () => {
                    debug.finish();
                },
            });
        });
    }
    async uploadImage(local_id) {
        if (config.is_dev) {
            console.log("Local development mode: mocking uploadImage");
            return "dev_server_id";
        }
        let debug = new DEBUG("WX UPDATE IMAGE");
        return new Promise((resolve, reject) => {
            if (config.debug) Toast.loading({ message: "正在上传图片...", duration: 0 });
            wx.uploadImage({
                localId: local_id,
                isShowProgressTips: 0,
                success: (res) => {
                    debug.log("success", { serverId: res.serverId });
                    if (config.debug) Toast.clear();
                    resolve(res.serverId);
                },
                fail: (err) => {
                    debug.log("failed", { error: err.errMsg });
                    if (config.debug) Toast.fail("上传图片失败");
                    reject(err);
                },
                complete: () => {
                    debug.finish();
                },
            });
        });
    }
    async startRecord() {
        if (config.is_dev) {
            console.log("Local development mode: mocking startRecord");
            return;
        }
        let debug = new DEBUG("WX BEGAN RECORD");
        while (this.init === false) {
            await sleep(20);
        }
        return new Promise((resolve, reject) => {
            if (config.debug) Toast.loading({ message: "准备录音...", duration: 0 });
            wx.startRecord({
                success: () => {
                    debug.log("success", { status: "Recording started" });
                    if (config.debug) Toast.success("正在录音...");
                    resolve();
                },
                fail: (err) => {
                    debug.log("failed", { error: err.errMsg });
                    if (config.debug) Toast.fail("录音启动失败");
                    reject(err);
                },
                complete: () => {
                    debug.finish();
                },
            });
        });
    }
    async stopRecord() {
        if (config.is_dev) {
            console.log("Local development mode: mocking stopRecord");
            return "dev_voice_local_id";
        }
        let debug = new DEBUG("WX STOP RECORD");
        return new Promise((resolve, reject) => {
            if (config.debug) Toast.loading({ message: "正在停止录音...", duration: 0 });
            wx.stopRecord({
                success: (res) => {
                    debug.log("success", { localId: res.localId });
                    if (config.debug) Toast.clear();
                    resolve(res.localId);
                },
                fail: (err) => {
                    debug.log("failed", { error: err.errMsg });
                    if (config.debug) Toast.fail("停止录音失败");
                    reject(err);
                },
                complete: () => {
                    debug.finish();
                },
            });
        });
    }
    async uploadRecord(local_id) {
        if (config.is_dev) {
            console.log("Local development mode: mocking uploadRecord");
            return "dev_voice_server_id";
        }
        let debug = new DEBUG("WX UPLOAD RECORD");
        return new Promise((resolve, reject) => {
            if (config.debug) Toast.loading({ message: "正在上传音频...", duration: 0 });
            wx.uploadVoice({
                localId: local_id,
                isShowProgressTips: 0,
                success: (res) => {
                    debug.log("success", { serverId: res.serverId });
                    if (config.debug) Toast.clear();
                    resolve(res.serverId);
                },
                fail: (err) => {
                    debug.log("failed", { error: err.errMsg });
                    if (config.debug) Toast.fail("上传音频失败");
                    reject(err);
                },
                complete: () => {
                    debug.finish();
                },
            });
        });
    }

    /**
     * 下载文件（适用于 H5 环境，通过 fetch 获取 Blob）
     * @param {string} url - 文件URL
     * @returns {Promise<Blob>} - 返回文件Blob对象
     */
    /**
     * 下载文件（支持 H5 环境，优先使用 fetch，失败时图片尝试用 Canvas 兼容）
     * @param {string} url - 文件URL
     * @returns {Promise<Blob>} - 返回文件Blob对象
     */
    async downloadFile(url) {
        let debug = new DEBUG("WX DOWNLOAD FILE");
        try {
            debug.log("request", { url });
            if (config.debug) Toast.loading({ message: "正在同步文件...", duration: 0 });

            // 尝试标准的 fetch
            try {
                const response = await fetch(url, {
                    method: "GET",
                    mode: "cors",
                    cache: "no-cache",
                });

                if (response.ok) {
                    const blob = await response.blob();
                    debug.log("success", { url, size: blob.size, method: "fetch" });
                    if (config.debug) Toast.clear();
                    return blob;
                }
            } catch (fetchError) {
                debug.log("fetch_failed", { error: fetchError.message });
                // 如果 fetch 失败，且是图片，尝试使用 Image + Canvas 方案
                if (url.match(/\.(jpg|jpeg|png|webp)$/i)) {
                    debug.log("retry", { message: "Attempting Image+Canvas fallback" });
                    return await this.downloadImageViaCanvas(url, debug);
                }
                throw fetchError;
            }

            throw new Error("下载失败，服务器响应异常");
        } catch (error) {
            console.error("下载文件最终出错:", error);
            debug.log("failed", { url, error: error.message });
            if (config.debug) Toast.fail(`同步失败: 请检查手机与树莓派是否连接同一WiFi`);
            throw error;
        } finally {
            debug.finish();
        }
    }

    /**
     * 通过 Canvas 转换图片为 Blob（兼容 fetch 被拦截的情况）
     */
    async downloadImageViaCanvas(url, debug) {
        return new Promise((resolve, reject) => {
            const img = new Image();
            img.crossOrigin = "Anonymous"; // 必须设置，且服务器需支持 CORS
            img.onload = () => {
                try {
                    const canvas = document.createElement("canvas");
                    canvas.width = img.width;
                    canvas.height = img.height;
                    const ctx = canvas.getContext("2d");
                    ctx.drawImage(img, 0, 0);
                    canvas.toBlob((blob) => {
                        if (blob) {
                            debug.log("success", { url, size: blob.size, method: "canvas" });
                            if (config.debug) Toast.clear();
                            resolve(blob);
                        } else {
                            reject(new Error("Canvas 转换 Blob 失败"));
                        }
                    }, "image/jpeg");
                } catch (e) {
                    reject(e);
                }
            };
            img.onerror = () => reject(new Error("图片加载失败，请确保树莓派服务器已开启且可访问"));
            img.src = url + (url.indexOf("?") > -1 ? "&" : "?") + "t=" + new Date().getTime(); // 加随机数防止缓存
        });
    }
}

function randomString(length = 4, map = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ") {
    let str = "";
    for (let i = 0; i < length; i++) {
        let rand = Math.random() * map.length;
        str = str + map[parseInt(rand)];
    }
    return str;
}

async function sleep(time) {
    return new Promise((resolve) => {
        setTimeout(resolve, time);
    });
}

export default {
    DEBUG,
    WX,
    randomString,
    sleep,
};
